import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CancelEnrollment200,
  CancelEnrollment401,
  CancelEnrollment403,
  CancelEnrollment404,
  CancelEnrollment500,
  CancelEnrollmentBody,
  CancelEnrollmentByCourseId200,
  CancelEnrollmentByCourseId401,
  CancelEnrollmentByCourseId403,
  CancelEnrollmentByCourseId404,
  CancelEnrollmentByCourseId500,
  CancelEnrollmentByCourseIdBody,
  CheckEnrollmentEligibility200,
  CheckEnrollmentEligibility401,
  CheckEnrollmentEligibility404,
  CheckEnrollmentEligibilityParams,
  EnrollCourse201,
  EnrollCourse400,
  EnrollCourse401,
  EnrollCourse404,
  EnrollCourse409,
  EnrollCourse500,
  EnrollCourseBody,
  GetEnrollment200,
  GetEnrollment401,
  GetEnrollment403,
  GetEnrollment404,
  UpdateEnrollmentProgress200,
  UpdateEnrollmentProgress400,
  UpdateEnrollmentProgress401,
  UpdateEnrollmentProgress404,
  UpdateEnrollmentProgressBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 특정 강좌에 수강신청을 합니다.

## 수강신청 조건
- 중복 수강신청 불가
- 강좌 수용 인원 확인
- 전제 조건 충족 필요
- 인증된 사용자만 가능

 * @summary 수강신청
 */
export const enrollCourse = (
    courseId: string,
    enrollCourseBody: EnrollCourseBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<EnrollCourse201>(
      {url: `/api/courses/${courseId}/enrollments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollCourseBody
    },
      options);
    }
  


export const getEnrollCourseMutationOptions = <TError = EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string;data: EnrollCourseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string;data: EnrollCourseBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrollCourse>>, {courseId: string;data: EnrollCourseBody}> = (props) => {
          const {courseId,data} = props ?? {};

          return  enrollCourse(courseId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnrollCourseMutationResult = NonNullable<Awaited<ReturnType<typeof enrollCourse>>>
    export type EnrollCourseMutationBody = EnrollCourseBody
    export type EnrollCourseMutationError = EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500

    /**
 * @summary 수강신청
 */
export const useEnrollCourse = <TError = EnrollCourse400 | EnrollCourse401 | EnrollCourse404 | EnrollCourse409 | EnrollCourse500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrollCourse>>, TError,{courseId: string;data: EnrollCourseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof enrollCourse>>,
        TError,
        {courseId: string;data: EnrollCourseBody},
        TContext
      > => {

      const mutationOptions = getEnrollCourseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Course ID를 사용해 현재 사용자의 수강신청을 취소합니다.

## 취소 정책
- 7일 이내: 100% 환불
- 14일 이내: 80% 환불
- 30일 이내: 50% 환불
- 30일 초과: 환불 불가

 * @summary 강좌 수강 취소 (Course ID로)
 */
export const cancelEnrollmentByCourseId = (
    courseId: string,
    cancelEnrollmentByCourseIdBody?: CancelEnrollmentByCourseIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CancelEnrollmentByCourseId200>(
      {url: `/api/courses/${courseId}/enrollments`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelEnrollmentByCourseIdBody
    },
      options);
    }
  


export const getCancelEnrollmentByCourseIdMutationOptions = <TError = CancelEnrollmentByCourseId401 | CancelEnrollmentByCourseId403 | CancelEnrollmentByCourseId404 | CancelEnrollmentByCourseId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>, TError,{courseId: string;data: CancelEnrollmentByCourseIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>, TError,{courseId: string;data: CancelEnrollmentByCourseIdBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>, {courseId: string;data: CancelEnrollmentByCourseIdBody}> = (props) => {
          const {courseId,data} = props ?? {};

          return  cancelEnrollmentByCourseId(courseId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEnrollmentByCourseIdMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>>
    export type CancelEnrollmentByCourseIdMutationBody = CancelEnrollmentByCourseIdBody
    export type CancelEnrollmentByCourseIdMutationError = CancelEnrollmentByCourseId401 | CancelEnrollmentByCourseId403 | CancelEnrollmentByCourseId404 | CancelEnrollmentByCourseId500

    /**
 * @summary 강좌 수강 취소 (Course ID로)
 */
export const useCancelEnrollmentByCourseId = <TError = CancelEnrollmentByCourseId401 | CancelEnrollmentByCourseId403 | CancelEnrollmentByCourseId404 | CancelEnrollmentByCourseId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>, TError,{courseId: string;data: CancelEnrollmentByCourseIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelEnrollmentByCourseId>>,
        TError,
        {courseId: string;data: CancelEnrollmentByCourseIdBody},
        TContext
      > => {

      const mutationOptions = getCancelEnrollmentByCourseIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 수강신청의 상세 정보를 조회합니다.

## 조회 가능 정보
- 수강신청 기본 정보
- 학습 진행도
- 수료증 정보
- 수강 이력

 * @summary 수강신청 정보 조회
 */
export const getEnrollment = (
    enrollmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetEnrollment200>(
      {url: `/api/enrollments/${enrollmentId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnrollmentQueryKey = (enrollmentId: string,) => {
    return [`/api/enrollments/${enrollmentId}`] as const;
    }

    
export const getGetEnrollmentInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404>(enrollmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnrollmentQueryKey(enrollmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnrollment>>> = ({ signal }) => getEnrollment(enrollmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnrollmentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getEnrollment>>>
export type GetEnrollmentInfiniteQueryError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404

/**
 * @summary 수강신청 정보 조회
 */
export const useGetEnrollmentInfinite = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404>(
 enrollmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEnrollmentInfiniteQueryOptions(enrollmentId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetEnrollmentQueryOptions = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404>(enrollmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnrollmentQueryKey(enrollmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnrollment>>> = ({ signal }) => getEnrollment(enrollmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnrollmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEnrollment>>>
export type GetEnrollmentQueryError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404

/**
 * @summary 수강신청 정보 조회
 */
export const useGetEnrollment = <TData = Awaited<ReturnType<typeof getEnrollment>>, TError = GetEnrollment401 | GetEnrollment403 | GetEnrollment404>(
 enrollmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnrollment>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEnrollmentQueryOptions(enrollmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 수강신청을 취소합니다.

## 취소 정책
- 7일 이내: 100% 환불
- 14일 이내: 80% 환불
- 30일 이내: 50% 환불
- 30일 초과: 환불 불가

 * @summary 수강 취소
 */
export const cancelEnrollment = (
    enrollmentId: string,
    cancelEnrollmentBody?: CancelEnrollmentBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CancelEnrollment200>(
      {url: `/api/enrollments/${enrollmentId}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelEnrollmentBody
    },
      options);
    }
  


export const getCancelEnrollmentMutationOptions = <TError = CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string;data: CancelEnrollmentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string;data: CancelEnrollmentBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEnrollment>>, {enrollmentId: string;data: CancelEnrollmentBody}> = (props) => {
          const {enrollmentId,data} = props ?? {};

          return  cancelEnrollment(enrollmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEnrollment>>>
    export type CancelEnrollmentMutationBody = CancelEnrollmentBody
    export type CancelEnrollmentMutationError = CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500

    /**
 * @summary 수강 취소
 */
export const useCancelEnrollment = <TError = CancelEnrollment401 | CancelEnrollment403 | CancelEnrollment404 | CancelEnrollment500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEnrollment>>, TError,{enrollmentId: string;data: CancelEnrollmentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelEnrollment>>,
        TError,
        {enrollmentId: string;data: CancelEnrollmentBody},
        TContext
      > => {

      const mutationOptions = getCancelEnrollmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 수강생의 학습 진도를 업데이트합니다.

## 진도 관리
- 레슨별 완료 상태 추적
- 모듈별 완료 상태 추적
- 전체 진행률 자동 계산
- 예상 완료 일자 계산

 * @summary 학습 진도 업데이트
 */
export const updateEnrollmentProgress = (
    enrollmentId: string,
    updateEnrollmentProgressBody: UpdateEnrollmentProgressBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UpdateEnrollmentProgress200>(
      {url: `/api/enrollments/${enrollmentId}/progress`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateEnrollmentProgressBody
    },
      options);
    }
  


export const getUpdateEnrollmentProgressMutationOptions = <TError = UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEnrollmentProgress>>, {enrollmentId: string;data: UpdateEnrollmentProgressBody}> = (props) => {
          const {enrollmentId,data} = props ?? {};

          return  updateEnrollmentProgress(enrollmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEnrollmentProgressMutationResult = NonNullable<Awaited<ReturnType<typeof updateEnrollmentProgress>>>
    export type UpdateEnrollmentProgressMutationBody = UpdateEnrollmentProgressBody
    export type UpdateEnrollmentProgressMutationError = UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404

    /**
 * @summary 학습 진도 업데이트
 */
export const useUpdateEnrollmentProgress = <TError = UpdateEnrollmentProgress400 | UpdateEnrollmentProgress401 | UpdateEnrollmentProgress404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnrollmentProgress>>, TError,{enrollmentId: string;data: UpdateEnrollmentProgressBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateEnrollmentProgress>>,
        TError,
        {enrollmentId: string;data: UpdateEnrollmentProgressBody},
        TContext
      > => {

      const mutationOptions = getUpdateEnrollmentProgressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 강좌의 수강 가능 여부를 사전에 확인합니다.

## 확인 항목
- 중복 수강신청 여부
- 전제 조건 충족 여부
- 수용 인원 여유 여부
- 결제 필요 여부

 * @summary 수강 가능 여부 확인
 */
export const checkEnrollmentEligibility = (
    courseId: string,
    params: CheckEnrollmentEligibilityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CheckEnrollmentEligibility200>(
      {url: `/api/courses/${courseId}/enrollment-eligibility`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCheckEnrollmentEligibilityQueryKey = (courseId: string,
    params: CheckEnrollmentEligibilityParams,) => {
    return [`/api/courses/${courseId}/enrollment-eligibility`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckEnrollmentEligibilityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404>(courseId: string,
    params: CheckEnrollmentEligibilityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckEnrollmentEligibilityQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkEnrollmentEligibility>>> = ({ signal }) => checkEnrollmentEligibility(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckEnrollmentEligibilityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof checkEnrollmentEligibility>>>
export type CheckEnrollmentEligibilityInfiniteQueryError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404

/**
 * @summary 수강 가능 여부 확인
 */
export const useCheckEnrollmentEligibilityInfinite = <TData = Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404>(
 courseId: string,
    params: CheckEnrollmentEligibilityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCheckEnrollmentEligibilityInfiniteQueryOptions(courseId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCheckEnrollmentEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404>(courseId: string,
    params: CheckEnrollmentEligibilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckEnrollmentEligibilityQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkEnrollmentEligibility>>> = ({ signal }) => checkEnrollmentEligibility(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckEnrollmentEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof checkEnrollmentEligibility>>>
export type CheckEnrollmentEligibilityQueryError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404

/**
 * @summary 수강 가능 여부 확인
 */
export const useCheckEnrollmentEligibility = <TData = Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError = CheckEnrollmentEligibility401 | CheckEnrollmentEligibility404>(
 courseId: string,
    params: CheckEnrollmentEligibilityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkEnrollmentEligibility>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCheckEnrollmentEligibilityQueryOptions(courseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



